/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/first */
declare var Accept: any;
import React, { FC, ReactElement, useState, useEffect } from 'react';
import withLocalization from '../hoc/withLocalization';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { useNavigate } from 'react-router-dom';
import {
  setPaymentFormToken,
  resetPaymentData,
  bookConfirmationPayment,
  setpaymentLoader,
  resetPaymentContextId,
  resetPaymentModalError,
  payerAuthConfirmation,
  resetAllPaymentPageDetails,
  clearPayerAuthDetails,
  retrieveUCPaymentContext,
  setTestPaymentContextId,
  retrieveUCPaymentDetails,
} from '../../features/OfferPaymentContainer/OfferPaymentSlice';
import PaymentErrorModal from '../Modal/PaymentErrorModal/PaymentErrorModal';
import CyberSourceErrorModal from '../Modal/CyberSourceErrorModal/CyberSourceErrorModal';
import { IP_ADDR_REQUEST_URL } from '../../util/strings';
import { paymentOfferPayload } from '../../util/paymentRequestMapping';
import { payerAuthPayload } from '../../util/PayerAuthMaping';
import { CaptureContextBody } from './types';
import TermsAndConditionPage from './TermAndConditionPage';
import { UnifiedCheckoutContextPayload, UnifiedCheckoutPaymentDetailPayload } from '../NewOfferCyberSource/types';
import leftArrowLogo from '../../features/siteTheme/Brands/tmvcs/logo/leftArrowLogo.svg';
import leftArrowHover from '../../features/siteTheme/Brands/tmvcs/logo/leftArrowHover.svg';
import NewOfferLoader from '../common/NewOfferLoader/NewOfferLoader';
import { analyticsData } from '../../analyticsTypes';
import { getPaymentTypeFromToken } from '../NewOfferCyberSource/paymentUtil';
import { useMediaQuery } from 'react-responsive';
import { refinePackageData } from '../../util/packagingOverviewMapping';
import PackageOverviewSummary from '../PackageOverviewPage/PackageOverviewSummary';
import { getMerchantGroupId } from '../../util/CommonLogic';
import { getMerchantGroupIdByCountry } from '../../util/mid';
import { getSiteIdentifier } from '../../util/SiteDetails';
import './UnifiedCheckout.scss';

interface UnifiedCheckoutFormType {
  localize: any;
  localizeImagesByNode: any;
  errPhoneNo?: any;
  logAnalytics: (data: analyticsData) => void;
}
const UnifiedCheckout: FC<UnifiedCheckoutFormType> = (props: UnifiedCheckoutFormType): ReactElement => {
  const { localize, localizeImagesByNode, logAnalytics, errPhoneNo } = props;
  const navigate = useNavigate();
  const defaultMerchantGroupId = getMerchantGroupId();

  const [secureAcceptanceLoaded, setsecureAcceptanceLoaded] = useState(false);
  const hasError = useSelector((state: RootState) => state.newOfferPaymentDetails.hasPaymentContextError);
  const paymentContextId = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentContextId);

  const isPinOptFlow: boolean = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFLow);
  const newOfferData: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);

  const offerData: any = (newOfferData?.offers && newOfferData?.offers[0]) || '';
  const packageData = refinePackageData(offerData);
  const roomType = (offerData?.roomTypes && offerData?.roomTypes[0]) || {};
  const depositAmt = roomType?.depositAmount || '';
  const billingInfo = useSelector((state: RootState) => state.newOfferPaymentDetails.billingDetailInfo);

  const pinPospectInfo: any = useSelector((state: RootState) => state.offerDetails.prospect) || '';
  const pinLeadDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFlowLeadInfo);
  const isCallMe: boolean = useSelector((state: RootState) => state.pinOptFlowDetails.isContactMeChecked);
  const pinDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  const isModalErr = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalError);
  const modalErrMsg = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalErrMsg);
  const modalErrStatus = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalErrStatus);
  const payAuthDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.PayerAuthDetails);
  const isPaymentErr = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentError);
  const hasContextError = useSelector((state: RootState) => state.newOfferPaymentDetails.hasPaymentContextError);
  const transientToken = useSelector((state: RootState) => state.newOfferPaymentDetails.transientToken);
  const authEnrollDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentAuthEnrollDetails);
  const payerAuthRefId = useSelector((state: RootState) => state.newOfferPaymentDetails.referenceId);
  const confirmationDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.confirmationDetails);
  const isPaymentCheck = useSelector((state: RootState) => state.newOfferPaymentDetails.isPaymentCheckBox);
  const mailingData: any = useSelector((state: RootState) => state.newOfferPaymentDetails.mailingAddressInfo);
  const ucBillToDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.ucPaymentDetails);
  const countriesData: any = useSelector((state: RootState) => state.pinOptFlowDetails.countriesData);
  const offerCountry = roomType?.property?.country || '';
  const merchantGroupId = getMerchantGroupIdByCountry(offerCountry) || defaultMerchantGroupId;

  const useTestCaptureContext = process.env.REACT_APP_USE_TEST_CAPTURE_CONTEXT?.toLowerCase() === 'true';
  const [testCaptureContext, setTestCaptureContext] = useState('');
  const isLoading = useSelector((state: RootState) => state.newOfferPaymentDetails.pageLoading);
  const [isTokenErr, setIsTokenErr] = useState(false);
  const [showErrModal, setShowErrModal] = useState(false);
  const [ipAddress, setSetIpAddress] = useState('');
  const [termsError, setTermError] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isCaptureContext, setIsCaptureContext] = useState(false);
  const dispatch = useDispatch();
  const siteIdentifier = getSiteIdentifier();
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  //Add id for persist same page when click close button on eror modal
  const scriptId = 'secure-acceptance-script-id';
  const errDetails = {
    errPhNo: errPhoneNo || '',
    callCenterCode: pinPospectInfo?.callCenterCode,
    countryName: pinPospectInfo?.countryCode,
  };
  const paymentMethodImage = localizeImagesByNode(
    'preview-sales-engine.static-content.images.intl-payment-methods-image',
    'intl-unified-checkout-payment-methods-desktop-main',
  );
  const mobPaymentMethodImage = localizeImagesByNode(
    'preview-sales-engine.static-content.images.intl-payment-methods-image',
    'intl-unified-checkout-payment-methods-mobile-main',
  );
  const paymentMethodImagePath = isMobile ? mobPaymentMethodImage?.path || '' : paymentMethodImage?.path || '';
  const paymentMethodImageAlt = isMobile
    ? mobPaymentMethodImage?.description || ''
    : paymentMethodImage?.description || '';

  const handlelogAnalytics = (data: analyticsData) => {
    // bubble event to parent
    if (logAnalytics) {
      logAnalytics(data);
    }
  };

  const handleTestCaptureContextChange = (evt: any) => {
    const testCC = evt.target.value;
    setTestCaptureContext(testCC);
    dispatch(setTestPaymentContextId(testCC));
  };

  const handleClickOnBack = () => {
    setIsCaptureContext(true);
    setTestCaptureContext('');
    dispatch(resetPaymentData());
    dispatch(resetAllPaymentPageDetails());
    dispatch(resetPaymentContextId());
    sessionStorage.removeItem('pbeJwtToken');
    const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
    navigate('/offer-details' + getUrlSearchParam);
  };

  useEffect(() => {
    if ((!paymentContextId || paymentContextId?.length === 0) && !hasError && isCaptureContext === false) {
      if (useTestCaptureContext) {
        dispatch(setTestPaymentContextId(testCaptureContext));
      } else {
        //const zipCodeVal: any = formateZipCode(pinPospectInfo?.postalCode);
        const ucContextPayload: UnifiedCheckoutContextPayload = {
          targetOrigins: [window.location.origin],
          country: pinPospectInfo?.countryCode || '',
          locale: 'en_US',
          captureMandate: {
            billingType: 'FULL',
            requestEmail: false,
            requestPhone: false,
            requestShipping: false,
            showAcceptedNetworkIcons: true,
          },
          orderInformation: {
            amountDetails: {
              totalAmount: depositAmt.replace('$', '').replace(',', ''),
              currency: 'USD',
            },
            billTo: {
              firstName: pinPospectInfo?.firstName || '',
              lastName: pinPospectInfo?.lastName || '',
              address1: mailingData?.address || pinPospectInfo?.addressLine1 || '',
              buildingNumber: '',
              locality: mailingData?.city || pinPospectInfo?.city || '',
              administrativeArea: mailingData?.stateCode || pinPospectInfo?.stateProvince || '',
              country: pinPospectInfo?.countryCode || '',
              postalCode: mailingData?.zipCode || pinPospectInfo?.postalCode || '',
            },
          },
        };
        dispatch(retrieveUCPaymentContext(merchantGroupId, ucContextPayload));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentContextId]);

  useEffect(() => {
    if (paymentContextId && paymentContextId.length > 0) {
      const captureContext: CaptureContextBody = JSON.parse(atob(paymentContextId.split('.')[1]));
      const clientLibrary = captureContext?.ctx?.[0].data?.clientLibrary ?? '';
      const script = document.createElement('script');
      script.src = clientLibrary;
      script.integrity = captureContext?.ctx?.[0].data?.clientLibraryIntegrity ?? '';
      script.id = scriptId;
      script.crossOrigin = 'anonymous';
      script.async = true;
      script.onload = () => {
        setsecureAcceptanceLoaded(true);
      };
      document.head.appendChild(script);
      return () => {
        //remove script place of removechild when click close button on eror modal
        script.remove();
        // document.head.removeChild(script);
      };
    }
  }, [paymentContextId]);

  useEffect(() => {
    fetch(IP_ADDR_REQUEST_URL)
      .then((response) => response.json())
      .then((data) => {
        const ipAdd = data?.ip || 'Unknown IP Address';
        setSetIpAddress(ipAdd);
      });
  }, []);

  useEffect(() => {
    if (hasContextError) {
      setIsTokenErr(true);
    }
  }, [hasContextError]);

  const submitPayment = (cdlId: any, refId: any, trID: any) => {
    const paymentType = getPaymentTypeFromToken(transientToken);
    const isdigitalWallet = paymentType?.value === 'CC' ? false : true;
    const getToken: any = sessionStorage.getItem('pbeJwtToken');
    const requestBookingData = paymentOfferPayload(
      offerData,
      billingInfo,
      pinPospectInfo,
      getToken,
      refId,
      trID,
      ipAddress,
      pinLeadDetails,
      isCallMe,
      pinDetails,
      mailingData,
      ucBillToDetails,
      countriesData,
    );

    dispatch(bookConfirmationPayment(requestBookingData, isdigitalWallet));
  };

  const payerAuthEnrollment = (payAttempt: any) => {
    const cardinal = window.Cardinal;
    console.log('we are in Enrollment');
    cardinal?.continue(
      'cca',
      {
        AcsUrl: payAttempt.acsUrl,
        Payload: payAttempt.paReq,
      },
      {
        OrderDetails: {
          TransactionId: payAttempt.transactionId,
        },
      },
    );

    cardinal?.on('payments.validated', async (data: any, cardinaljwt: any) => {
      console.log('After cardinal CONTINUE we are in payment validate data - ', data?.ActionCode);
      const validateData = data?.ActionCode?.toUpperCase() || 'default';
      if (validateData === 'FAILURE' || validateData === 'ERROR') {
        setShowErrModal(true);
      } else {
        const prTransId = data?.Payment?.ProcessorTransactionId || payAttempt.transactionId;
        submitPayment('', '', prTransId);
      }
    });
  };

  const setupCardinal = (cardinalJwt: any, referenceId: any, token: any, methodName?: any) => {
    const cardinal = window.Cardinal;
    console.log('we are in cardinal setup');
    console.log('is window cardinal define - ', cardinal);

    cardinal?.configure({
      logging: {
        level: 'on',
      },
    });
    cardinal?.setup('init', {
      jwt: cardinalJwt,
    });
    cardinal?.on('payments.setupComplete', function (setupCompleteData: any) {
      console.log('submit OTP');
      submitPayment(cardinalJwt, payerAuthRefId, '');
    });
  };

  useEffect(() => {
    if (payAuthDetails && payAuthDetails?.payerAuthEnabled && payAuthDetails?.referenceId !== '') {
      //dispatch(setpaymentLoader(false));
      const getToken = sessionStorage.getItem('pbeJwtToken');
      setupCardinal(payAuthDetails?.cardinalJwt, payAuthDetails?.referenceId, getToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payAuthDetails]);

  useEffect(() => {
    if (authEnrollDetails?.status?.toLowerCase() === 'pending_authentication') {
      //dispatch(setpaymentLoader(false));
      payerAuthEnrollment(authEnrollDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authEnrollDetails]);

  useEffect(() => {
    const confirmationStatus = confirmationDetails?.status?.toLowerCase() || '';
    if (confirmationStatus === 'pending_authentication') {
      payerAuthEnrollment(confirmationDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmationDetails]);

  useEffect(() => {
    if (isModalErr && modalErrStatus) {
      const errSt = modalErrStatus.toUpperCase();
      if (errSt === 'IIB_ERROR' || errSt === 'PAYMENT_DONE_BOOKING_FAILED') {
        const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
        navigate('/thank-you' + getUrlSearchParam);
      } else {
        setShowErrModal(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalErr, modalErrStatus]);

  if (isPaymentErr) {
    navigate('/error', { state: errDetails });
  }

  const confirmAndContinue = (token: string) => {
    dispatch(setPaymentFormToken(token));
    // set billing info from token
    const ucPaymentDetailPayload: UnifiedCheckoutPaymentDetailPayload = {
      transientToken: token,
    };
    dispatch(retrieveUCPaymentDetails(merchantGroupId, ucPaymentDetailPayload));
  };

  const closePaymentErrModal = () => {
    /* Start Add code for persist same page when click close button on eror modal */
    setTermsAccepted(false);
    const btnContainer = document.getElementById('buttonPaymentListContainer');
    const formContainer = document.getElementById('embeddedPaymentContainer');
    if (btnContainer) btnContainer.innerHTML = '';
    if (formContainer) formContainer.innerHTML = '';
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      document.head.removeChild(existingScript);
      setsecureAcceptanceLoaded(false); // Optional: update state
    }
    /* End Add code for persist same page when click close button on eror modal */
    //setIsCaptureContext(true);
    sessionStorage.removeItem('pbeJwtToken');
    dispatch(clearPayerAuthDetails());
    dispatch(resetAllPaymentPageDetails());
    setTestCaptureContext('');
    dispatch(resetPaymentData());
    dispatch(resetPaymentContextId());
    dispatch(resetPaymentModalError());

    setShowErrModal(false);
    setIsTokenErr(false);
    /* comment line  for persist same page when click close button on eror modal */
    //const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
    //navigate('/offer-details' + getUrlSearchParam);
  };

  useEffect(() => {
    const showArgs = {
      containers: {
        paymentSelection: '#buttonPaymentListContainer',
        paymentScreen: '#embeddedPaymentContainer',
      },
    };
    if (secureAcceptanceLoaded && paymentContextId && paymentContextId.length > 0) {
      const captureContext = JSON.parse(atob(paymentContextId.split('.')[1]));
      Accept(paymentContextId)
        .then((accept: any) => {
          console.log({ accept: accept });
          //have to pass in false when paymentScreen is configured to inline in containers
          return accept.unifiedPayments(false);
          //if paymentScreen is not included above, need to pass in empty value, which will use sidebar for payment entry
          // return accept.unifiedPayments();
        })
        .then((up: any) => {
          console.log({ up: up });
          return up.show(showArgs);
        })
        .then((tt: any) => {
          // this occurs when user clicks 'Confirm and 'Continue'
          sessionStorage.setItem('pbeJwtToken', tt);
          confirmAndContinue(tt);
        })
        .catch((error: any) => {
          console.log(error);
          dispatch(setpaymentLoader(false));
          setIsTokenErr(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentContextId, secureAcceptanceLoaded]);

  // create use effect after billing info is set in confirmandContinue
  useEffect(() => {
    if (billingInfo?.address) {
      try {
        const paymentType = getPaymentTypeFromToken(transientToken);
        const isCreditCard = paymentType?.value === 'CC' ? true : false;
        const analyticsData: analyticsData = {
          googleData: {
            event: 'add_payment_info',
            otherData: {
              payment_type: paymentType.text,
            },
          },
          adobeData: {
            event: 'PbeSubmitPayment',
            bookingStepName: 'MVC ' + siteIdentifier + '| PBE Payment',
            otherData: {
              paymentType: paymentType.text,
            },
          },
        };
        handlelogAnalytics(analyticsData);
        if (isCreditCard) {
          const requestBookingData = paymentOfferPayload(
            offerData,
            billingInfo,
            pinPospectInfo,
            transientToken,
            '',
            '',
            ipAddress,
            pinLeadDetails,
            isCallMe,
            pinDetails,
            mailingData,
            ucBillToDetails,
            countriesData,
          );
          const authData = payerAuthPayload(offerData, pinPospectInfo, transientToken, ipAddress, pinLeadDetails);
          const payloadObj = {
            bookingRequestObj: requestBookingData,
            authDataObj: authData,
            ispinOptFlow: isPinOptFlow,
          };
          dispatch(payerAuthConfirmation(payloadObj, false));
        } else {
          submitPayment('', '', '');
        }
      } catch (error) {
        console.log(error);
        dispatch(setpaymentLoader(false));
        setIsTokenErr(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingInfo]);

  const showTermError = () => {
    if (!isPaymentCheck) {
      setTermError(localize('preview-sales-engine.static-content.copy.pbeo.terms-conditions-error-message'));
    } else {
      setTermError('');
    }
  };

  const handlePaymentMethodImageClick = () => {
    showTermError();
  };

  useEffect(() => {
    if (isPaymentCheck !== termsAccepted) {
      setTermsAccepted(isPaymentCheck);
      showTermError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentCheck]);
  return (
    <>
      {isLoading && <NewOfferLoader />}
      {showErrModal && (
        <PaymentErrorModal
          closeModal={closePaymentErrModal}
          msg={modalErrMsg}
          phoneNo={errPhoneNo}
          prospectDetails={pinPospectInfo}
        />
      )}
      {isTokenErr && (
        <CyberSourceErrorModal
          closeModal={closePaymentErrModal}
          phoneNo={errPhoneNo}
          prospectDetails={pinPospectInfo}
        />
      )}
      {useTestCaptureContext && (
        <textarea
          id={'test-capture-context'}
          style={{ width: '100%' }}
          value={testCaptureContext}
          onChange={handleTestCaptureContextChange}
          // className="pin-input-cls"
        />
      )}
      <div className="uc-package-overview-summary">
        <span className="uc-label">{localize('preview-sales-engine.static-content.copy.pbeo.summary-label')}</span>
        <PackageOverviewSummary packageData={packageData} />
      </div>
      <div className="uc-terms-container">
        <span className="uc-label">
          {localize('preview-sales-engine.static-content.copy.pbeo.terms-and-conditions-label')}
        </span>
        <TermsAndConditionPage />
        {termsError && <span className="uc-terms-err">{termsError}</span>}
      </div>
      <div className="uc-payment-methods-container" style={{ display: !isPaymentCheck ? 'flex' : 'none' }}>
        <span className="uc-label">
          {localize('preview-sales-engine.static-content.copy.pbeo.payment-methods-header')}
        </span>
        <input
          type="image"
          src={paymentMethodImagePath}
          alt={paymentMethodImageAlt}
          onClick={handlePaymentMethodImageClick}
        ></input>
      </div>
      <div
        className="uc-main-container"
        style={{ display: isPaymentCheck && paymentContextId && paymentContextId.length > 0 ? 'flex' : 'none' }}
      >
        <div className="uc-button-container" id="buttonPaymentListContainer"></div>
        <div className="uc-payment-container" id="embeddedPaymentContainer"></div>
      </div>
      <div className="payment-btn-container">
        <button onClick={handleClickOnBack} className={`payment-back-btn`}>
          <img src={leftArrowLogo} alt="Back" className="back-icon-payment" />
          <img src={leftArrowHover} alt="Back" className="back-icon-payment-hover" />
          {localize(`preview-sales-engine.static-content.copy.pbeo.back-button-label`)}
        </button>
      </div>
    </>
  );
};

export default withLocalization(UnifiedCheckout);
